import http from '@/utils/http';

export default {
  list: (data) => http({ url: '/api/admin/v1/companyCancel/list', data }),
  detail: (data) => http({ url: '/api/admin/v1/companyCancel/detail', data }),
  audit: (data) => http({ url: '/api/admin/v1/companyCancel/audit', data, tip: true }),
};
